import { BookOpenIcon } from '@heroicons/react/24/outline';
import { createStaffMembersAdminPage } from './StaffMembersAdminPortal';

const LibrariansAdmin = createStaffMembersAdminPage({
  apiBase: '/admin/librarians',
  entityLabel: 'Librarian',
  entityLabelPlural: 'Librarians',
  accent: '#f59e0b',
  icon: BookOpenIcon,
  designationOptions: ['Librarian', 'Assistant Librarian', 'Library Assistant'],
  staffRole: 'librarian',
});

export default LibrariansAdmin;
